import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useParams } from "react-router-dom";

import { GetSpecialLearningContentById } from '../../../actions/learningcontent-actions';
import Loading from '../../shared/Loading'
import { removeLearningContentFromSession, setLearningContentSession, setLearningContentLevel } from '../../../utils/helpers/others/SessionHelper';


const SpecialLearningContent = () => {
    let { id } = useParams();
    const history = useHistory();
    const [loading, setLoading] = React.useState(true);

    useEffect(() => {
        const init = async () => {
            const response = await GetSpecialLearningContentById(id);
            if (response > 200 || response.status === "Failed") {
                return history.push("/SessionTimeOut")
            }

            const learningContent = {
                learningContentCategoryId: response.data.traitGroupId,
                learningContentCategoryName: response.data.traitGroupName,
                learningContentId: id,
                isAccessible: response.data.isAccessible,
                isRecommended: response.data.isRecommended,
                isCompleted: response.data.isCompleted,
            };

            setLoading(false);
            setLearningContentLevel(response.data.levelText > 0 ? response.data.levelText : 0);
            removeLearningContentFromSession();
            setLearningContentSession(JSON.stringify(learningContent));
            history.push("/LearningContent");
        }

        init();
    }, []);

    if (loading) return <Loading />

    return (
        <div></div>
    )
}

export default SpecialLearningContent;